import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const getUserMonitoring = createAsyncThunk(
  "userMonitoring/getAll",
  async (
    { offset = 0, limit = 10, search = "", startDate = "", endDate = "" } = {},
    { rejectWithValue },
  ) => {
    try {
      // Calculate 1-based page for the backend
      const page = Math.floor(offset / limit) + 1;

      const response = await api.get("/monitoring/user-monitoring", {
        params: {
          page,
          limit,
          search: search.trim() || undefined,
          startDate: startDate || undefined,
          endDate: endDate || undefined,
        },
      });

      // Standard response parsing
      const result = response.data;
      const inner = result?.data || {};
      const items = Array.isArray(inner.logs) ? inner.logs : [];
      const totalDocuments = Number(inner.totalLogs) || items.length;
      const totalPages = Number(inner.totalPages) || 1;

      // Map backend fields to frontend expected fields
      const mappedItems = items.map((item) => ({
        ...item,
        // Ensure consistent field names for the table columns
        ipAddress: item.ip || "—",
        device: `${item.deviceType || ""} ${item.os || ""}`.trim() || "—",
        username: item.userId?.username || item.email || "—",
        firstName: item.userId?.firstName || "",
        lastName: item.userId?.lastName || "",
        userId: item.userId?.userId || "",
        flag:
          item.status === "FAILURE" && item.failureReason === "User Not Found"
            ? {
                type: "suspicious",
                label: "Unregistered email login attempt",
                isSuspicious: true,
              }
            : item.riskFactors && item.riskFactors.length > 0
              ? {
                  type: "risk",
                  label: item.riskFactors.join(", "),
                  isSuspicious: item.isSuspicious,
                }
              : item.isSuspicious
                ? {
                    type: "suspicious",
                    label: "Suspicious Activity",
                    isSuspicious: true,
                  }
                : null,
      }));

      return {
        data: {
          items: mappedItems,
          pagination: {
            totalDocuments: totalDocuments,
            totalPages: totalPages,
            page: Number(inner.currentPage || page) || 1,
            limit: Number(limit) || 10,
          },
        },
      };
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Failed to fetch user monitoring data";
      return rejectWithValue({ message, code: err?.response?.status || 500 });
    }
  },
);
